import { useEffect, useState } from "react";
import { ComboBox } from "@/components/ComboBox";
import { Label } from "@/components/ui/label";
import { fl } from "@/lib/finI18n";
import { loadKop, autoKop } from "@/lib/kop";

export function KopSelect({ tax, value, onChange, text, lang }) {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    let off = false;
    loadKop(lang).then((d) => { if (!off) setRef(d); });
    return () => { off = true; };
  }, [lang]);
  const items = ref?.items || [];
  const auto = autoKop(ref, tax, text);
  const lbl = (c) => { const k = items.find((x) => x.code === c); return k ? `${k.code} · ${k.label}` : c; };
  const opts = [{ value: "", label: `${fl("kopAuto", lang)} · ${auto ? lbl(auto) : "—"}` }, ...items.map((k) => ({ value: k.code, label: `${k.code} · ${k.label}` }))];
  const missing = !value && !auto;
  return (
    <div className="space-y-1.5" data-testid="txn-kop-box">
      <Label>{fl("kop", lang)}</Label>
      <ComboBox testid="txn-kop" value={value || ""} onChange={onChange} options={opts} placeholder={opts[0].label} searchPlaceholder={fl("kopSearch", lang)} />
      <p className={`text-[11px] ${missing ? "text-amber-600" : "text-muted-foreground"}`} data-testid="txn-kop-hint">
        {fl(missing ? "kopMissing" : value ? "kopOverride" : "kopAutoHint", lang)}
      </p>
    </div>
  );
}
